import AlertModal from 'components/Modal/AlertModal';
import ConfirmModal from 'components/Modal/ConfirmModal';
import MigrationModal from 'components/Modal/MigrationModal';
import PromptModal from 'components/Modal/PromptModal';
import SettingsModal from 'components/Modal/SettingsModal';
import PlanPricingModal from 'components/Modal/PlanPricingModal';
import { shallowEqual, useSelector } from 'react-redux';
import { RootReducer, selectIsLoadingAnything } from 'redux/reducers';

const ModalManager = () => {
	const {
		globalPromptModalOptions,
		globalConfirmModalOptions,
		globalAlertModalOptions,
		migrationModal,
		planPricingModalVisible,
		settingsModalVisible,
	} = useSelector((r: RootReducer) => {
		return {
			loading: selectIsLoadingAnything(r),
			sceneLoadError: r.db.sceneLoadError,
			globalPromptModalOptions: r.mode.promptModal,
			globalConfirmModalOptions: r.mode.confirmModal,
			globalAlertModalOptions: r.mode.alertModal,
			migrationModal: r.mode.migrationModal,
			planPricingModalVisible: r.mode.planPricingModalVisible,
			settingsModalVisible: r.mode.settingsModalVisible,
		};
	}, shallowEqual);

	return (
		<>
			{globalPromptModalOptions && <PromptModal options={globalPromptModalOptions} />}
			{globalConfirmModalOptions && <ConfirmModal options={globalConfirmModalOptions} />}
			{globalAlertModalOptions && <AlertModal options={globalAlertModalOptions} />}
			{migrationModal && (
				<MigrationModal
					dsId={migrationModal.dsId}
					context={migrationModal.context}
					sceneId={migrationModal.sceneId}
				/>
			)}
			{planPricingModalVisible && <PlanPricingModal />}
			{settingsModalVisible && <SettingsModal />}
		</>
	);
};

export default ModalManager;
